<template>
    <div class="cup-playoff-table">
        <h3 class="playoff-title">Дополнительный этап</h3>
        <cup-group-table 
            :teams="teams" 
            :games="games"
            :is-playoff-stage="true"
        />
    </div>
</template>

<script setup>
import CupGroupTable from '@/components/features/results/CupGroupTable.vue';

const props = defineProps({
    teams: {
        type: Array,
        required: true,
        default: () => []
    },
    games: {
        type: Array,
        required: true,
        default: () => []
    }
});
</script>


